<template>
  <v-app style="height: 100%; " class="bg-primary">
    <v-main>
      <v-alert dense color="primary text-error" class="text-center pa-2" v-if="$store.state.activePage != 'splash' &&!!$store.state.info.top_banner && $store.state.info.top_banner.length > 2">
        {{ $store.state.info.top_banner }}
      </v-alert>
      <SplashPage v-if="$store.state.activePage == 'splash'"/>
      <BookingPage v-else-if="$store.state.activePage == 'booking'"/>
      <OrdersPage v-else-if="$store.state.activePage == 'orders_history'"/>
    </v-main>
    <Auth  v-if="$store.state.loginDialogStatus"/>
    <SubmitBookingPage  v-if="$store.state.bookingDialogStatus"/>
    <BookingSelectEmploye  v-if="$store.state.bookingSelectEmployeDialogStatus"/>
    <BookingSelectService  v-if="$store.state.bookingSelectServiceDialogStatus"/>
    <BookingSelectInfo  v-if="$store.state.bookingSelectInfoDialogStatus"/>
    
    
    <Profile  v-if="$store.state.showProfileDialogStatus"/>
  </v-app>
</template>

<script>

import OrdersPage from './pages/orders.vue';
import BookingPage from './pages/booking.vue';
import SplashPage from './pages/splash.vue';
import SubmitBookingPage from './components/submit_booking.vue';
import BookingSelectEmploye from './components/booking_select_employe.vue';
import BookingSelectService from './components/booking_select_service.vue';
import BookingSelectInfo from './components/booking_select_info.vue';
import Profile from './components/Profile.vue';
import Auth from './components/auth.vue';
export default {
  name: 'App',


  components: {
    Auth,
    Profile,
    SubmitBookingPage,
    BookingSelectEmploye,
    BookingSelectService,
    BookingSelectInfo,
    BookingPage,
    SplashPage,
    OrdersPage,
  },

  data: () => ({
    
  }),
  methods: {
  },
  async mounted() {
    await this.$store.dispatch('fetchAuthToken');
    await this.$store.dispatch('fetchBaseData');
  }
}
</script>

<style>
.Vue-Toastification__toast-body{
  font-family: 'iransans' !important;
  direction: rtl;
}

.main-bg-color{
  background: linear-gradient(135deg, #ffffff, rgb(233, 230, 233));
}
</style>
